export default {"src":"/_next/static/media/road2.ed39092f.svg","height":206,"width":206,"blurWidth":0,"blurHeight":0};